import { CredusText, CredusWrapper } from 'ui';
import DashboardLayout from '../layouts/dashboard';
import ReportStatistics from '../modules/report/ReportStatistics';
import FilterTable from '../modules/report/FilterTables';
import { BreadCrumb } from './TestManagement';
import { BiChevronRight } from 'react-icons/bi';
import useViewReport from '../modules/report/hooks/useViewReport';
import ComponentLoader from '../modules/test-management/ComponentLoader';
import { Link } from 'react-router-dom';

const ViewReport = () => {
  const { data, paramsData, setXport, isLoading } = useViewReport();

  return (
    <DashboardLayout
      breadCrumbs={
        <BreadCrumb>
          <Link to="/dashboard" className='breadcrumb-link'>
            <CredusText color={'#7a7a7a'} size="sm">
              Dashboard
            </CredusText>
          </Link>
          <BiChevronRight color={'#7a7a7a'} />
          <Link to="/report" className='breadcrumb-link'>
            <CredusText color={'#7a7a7a'} size="sm">
              View Report
            </CredusText>
          </Link>
        </BreadCrumb>
      }
    >
      {isLoading ? (
        <ComponentLoader loaderText="Loading..." />
      ) : (
        <>
          {paramsData && data?.data && (
            <ReportStatistics
              testDetailReport={data?.data}
              paramsData={paramsData}
            />
          )}
          <CredusWrapper mt="1.2rem" bg="#fff" padding="2.25rem 2.18rem">
            {data?.data && (
              <FilterTable testDetailReport={data?.data} setXport={setXport} />
            )}
          </CredusWrapper>
        </>
      )}
    </DashboardLayout>
  );
};

export default ViewReport;
